import { lazy } from 'react';

export const PlayerGlobalUpdateGamanzaStatusForm = lazy(
  () => import('./PlayerGlobalUpdateGamanzaStatusForm'),
);
